export const tablet = {
  name: "tablet" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M3.1 3c0-1.05.85-1.9 1.9-1.9h14c1.05 0 1.9.85 1.9 1.9v18a1.9 1.9 0 0 1-1.9 1.9H5A1.9 1.9 0 0 1 3.1 21V3ZM5 2.9a.1.1 0 0 0-.1.1v18a.1.1 0 0 0 .1.1h14a.1.1 0 0 0 .1-.1V3a.1.1 0 0 0-.1-.1H5ZM10.6 19a.9.9 0 0 1 .9-.9h1a.9.9 0 1 1 0 1.8h-1a.9.9 0 0 1-.9-.9Z" clip-rule="evenodd"/></svg>`,
  keywords: ["tablet"],
  category: "device" as const,
};
